<template>
  <Modal
    title="Promo Code"
    :disabled="!discountId"
    :saving="saving"
    @hide-modal="$emit('hide-modal')"
    @submit="handleApply"
  >
    <div class="promo-body min-h-[280px] md:min-h-0">
      <label class="full-width">
        Promo Code
        <Select
          v-model="discountId"
          placeholder="Select Promo Code"
          :options="options"
          @opened="open = true"
          @closed="open = false"
        />
      </label>
      <Transition>
        <div v-if="selectedDiscount">
          <span>
            The
            <b>{{ selectedDiscount.code }}</b>
            promo code expires on
            {{ formatDate(selectedDiscount.expires_at) }}
          </span>
        </div>
      </Transition>
    </div>
  </Modal>
</template>

<script>
import { mapActions, mapState } from "vuex";

import Modal from "../../components/Modal.vue";
import Transition from "../../components/Transition.vue";

export default {
  components: {
    Modal,
    Transition
  },
  props: {
    quote: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["hide-modal"],
  data() {
    return {
      discountId: null,
      saving: false,
      open: false
    };
  },
  computed: {
    ...mapState(["discounts"]),
    selectedDiscount() {
      return this.discounts.find((d) => d.id === this.discountId);
    },
    options() {
      return this.discounts.map((discount) => ({
        value: discount.id,
        label: this.discountLabel(discount)
      }));
    }
  },
  mounted() {
    if (this.discounts.length === 0) {
      this.fetchDiscounts();
    }
    this.setSelectedDiscount();
  },
  methods: {
    ...mapActions(["fetchDiscounts", "updateDiscount", "confirmQuoteChange"]),
    handleApply() {
      this.saving = true;

      this.confirmQuoteChange()
        .then(() => {
          this.$emit("hide-modal");
          this.saving = false;

          this.updateDiscount({
            quote_update_url: this.quote.links.quote_update,
            discountId: this.discountId
          });
        })
        .catch(() => (this.saving = false));
    },
    discountLabel(discount) {
      let value = 0;
      if (discount.kind === "percentage") {
        value = `${discount.percent}%`;
      } else {
        value = (discount.amount_cents / 100).toLocaleString("en-us", {
          style: "currency",
          currency: "USD"
        });
      }
      return `${discount.code} (${value} off)`;
    },
    formatDate(date) {
      return moment(date).format("MM/DD/YYYY");
    },
    setSelectedDiscount() {
      if (this.quote.discount_attributes) {
        this.discountId = this.quote.discount_attributes.id;
      }
    }
  }
};
</script>
